module.exports = __webpack_public_path__ + "static/img/linyi2.073dd03f.jpg";